"use strict";

exports.__esModule = true;
exports.textAreaPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var textAreaPropTypes = {
  autoSize: _propTypes.bool,
  className: _propTypes.string,
  defaultValue: _propTypes.string,
  disabled: _propTypes.bool,
  inputRef: _propTypes.func,
  rootProps: _propTypes.object,
  invalid: _propTypes.bool,
  onInput: _propTypes.func,
  onChange: _propTypes.func,
  readOnly: _propTypes.bool,
  required: _propTypes.bool,
  resizeable: _propTypes.bool,
  rows: _propTypes.number,
  size: (0, _propTypes.oneOf)(Object.keys(_constants.SIZE)),
  value: _propTypes.string,
  variant: (0, _propTypes.oneOf)(Object.keys(_constants.VARIANT))
};
exports.textAreaPropTypes = textAreaPropTypes;